import React, {useEffect, useState} from "react";
import {observer} from "mobx-react";
import {Col, Container, Row} from "react-bootstrap";
import OrderEntry from "./OrderEntry.jsx";
import OrderSummary from "./OrderSummary.jsx";
import Button from "react-bootstrap/Button";
import rootStore from "../../../../stores/rootStore.js";
import OrderPayment from "./OrderPayment.jsx";
import {useNavigate} from "react-router-dom";
import {stripeConfig} from "../../../../_helpers/stripeConfig.js";
import {Elements} from "@stripe/react-stripe-js";
function NewOrderPage(){

    const [orderProgress, setOrderProgress] = useState("entry");
    const taxCertOrderStore = rootStore.taxCertOrderStore;
    const navigate = useNavigate();
    const isPaymentStep = orderProgress === "payment";

    const handlePayForOrder = () => {
        taxCertOrderStore.getClientSecret().then(() => {
            setOrderProgress("payment");
        });
    }

    const handleModifyOrder = () => {
        setOrderProgress("entry");
    }
    const handleCancel = () => {
        taxCertOrderStore.clearOrder();
        navigate('/');
    }

    useEffect(() => {
        taxCertOrderStore.startNewOrder();
    }, []);

    return (
        <Container className="order-flow">
            <div className="dashboard-hero" data-accent="customer" style={{marginBottom: 20}}>
                <div>
                    <div className="dashboard-eyebrow">New Order</div>
                    <h1>Request a tax certificate</h1>
                    <p>Enter the property details, review pricing, and finalize payment.</p>
                </div>
            </div>
            <Row className="order-steps">
                <Col md={6}>
                    <div className={`order-step ${!isPaymentStep ? "active" : ""}`}>
                        <div className="step-label">Step 1</div>
                        <div className="step-title">Order Details</div>
                        <div className="step-subtitle">Choose the tax authority and search method.</div>
                    </div>
                </Col>
                <Col md={6}>
                    <div className={`order-step ${isPaymentStep ? "active" : ""}`}>
                        <div className="step-label">Step 2</div>
                        <div className="step-title">Payment</div>
                        <div className="step-subtitle">Securely pay and finalize the request.</div>
                    </div>
                </Col>
            </Row>
            <Row className="mt-4 order-panels">
                <Col lg={7} className="mb-4 mb-lg-0">
                    {orderProgress === "entry" && <OrderEntry/>}
                    {orderProgress === "payment" && taxCertOrderStore.paymentProvider === "Stripe" && taxCertOrderStore.clientSecret && (
                        <Elements stripe={stripeConfig.stripePromise} options={{clientSecret: taxCertOrderStore.clientSecret}}>
                            <OrderPayment onBack={handleModifyOrder} />
                        </Elements>
                    )}
                    {orderProgress === "payment" && taxCertOrderStore.paymentProvider !== "Stripe" && (
                        <OrderPayment onBack={handleModifyOrder} />
                    )}
                </Col>
                <Col lg={5}>
                    <OrderSummary/>
                </Col>
            </Row>
            <hr className="mt-4"/>
            <Row className="mt-3">
                <Col xs={12} className="d-flex flex-wrap gap-2 justify-content-between">
                    {orderProgress === "entry" && (
                        <Button disabled={!taxCertOrderStore.validOrder} onClick={handlePayForOrder}>
                            Continue to Payment
                        </Button>
                    )}
                    {orderProgress === "payment" && (
                        <Button variant="outline-secondary" className="ms-auto" onClick={handleModifyOrder}>
                            Back to Details
                        </Button>
                    )}
                    <Button variant="outline-danger" className="ms-auto" onClick={handleCancel}>
                        Cancel Order
                    </Button>
                </Col>
            </Row>
        </Container>
    )
}

export default observer(NewOrderPage);
